module.exports = __webpack_public_path__ + "img/pb.727ef7c3.webp";